import i18next from 'i18next';
import { IBoxCondition } from 'shared/types/BoxCondition';

export const getBoxConditionCopy = (boxCondition: IBoxCondition): string => {
  return {
    badly_damaged: i18next.t('productTemplate.damagedBox', 'Damaged Box'),
    missing_lid: i18next.t('productTemplate.missingLid', 'Missing Lid'),
    no_original_box: i18next.t('productTemplate.noOriginalBox', 'No Original Box'),
    good_condition: i18next.t('productTemplate.goodCondition', 'Good Condition'),
  }[boxCondition];
};
